export const MUSIC_BED_VOLUME = 100;

export const NO_VOICEOVER_MUSIC_VOLUME = 200;

export const DEFAULT_VOICEOVER_VOLUME = 200;
